// extracted by mini-css-extract-plugin
export default {"TribeMemberFormExpand":"TribeMemberDetailsForm_TribeMemberFormExpand__SMFyx","expand":"TribeMemberDetailsForm_expand__uMVR0"};